export class MarketStatisticsModel {
setValue(res){
if(res){
}
}
}